import { takeLatest, call, put, select } from 'redux-saga/effects'
import * as actions from './actions'
import axios from 'axios'
import { enqueueSnackbar } from '../root/actions'
import { getSagasMsgs } from '../root/selectors'

export const watchDetachedSharingSaga = [
    takeLatest(actions.DETACHED_SHARING_DATA_REQUEST, getDetachedSharingData),
    takeLatest(actions.SHARE_DETACHED_SHARING_DATA, shareDetachedSharingData)
]

function* getDetachedSharingData(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield put(actions.startDetachedSharingLoading())
        const detachedSharingData = yield call(getDetachedSharingDataRequest)
        yield put(actions.detachedSharingDataSuccess(detachedSharingData))
        const sharedUsers = yield call(getSharedUsersRequest)
        yield put(actions.sharedUsersSuccess(sharedUsers))
        yield put(actions.stopDetachedSharingLoading())
    } catch (ex) {
        yield put(actions.detachedSharingDataError())
        yield put(enqueueSnackbar({
            message: sagasMsgs.getDetachedSharingDataEx,
            options: {
                variant: 'error'
            }
        }))
        yield put(actions.stopDetachedSharingLoading())
    }
}

async function getDetachedSharingDataRequest() {
    const response = await axios.get(`${process.env.API_URL}/sharing/detached`)
    return response.data
}

async function getSharedUsersRequest() {
    const response = await axios.get(`${process.env.API_URL}/users/shared`)
    return response.data
}

function* shareDetachedSharingData(action) {
    const sagasMsgs = yield select(getSagasMsgs)
    try {
        yield call(shareDetachedSharingDataRequest, action.postShareData)
        yield put(actions.shareDetachedSharingDataSuccess())
        yield put(enqueueSnackbar({
            message: sagasMsgs.shareDetachedSharingDataRes,
            options: {
                variant: 'success'
            }
        }))
    } catch (ex) {
        yield put(actions.shareDetachedSharingDataError())
        yield put(enqueueSnackbar({
            message: sagasMsgs.shareDetachedSharingDataEx,
            options: {
                variant: 'error'
            }
        }))
    }
}

async function shareDetachedSharingDataRequest(body) {
    await axios.post(`${process.env.API_URL}/sharing/detached`, body)
}
